import { render, staticRenderFns } from "./ChangeOrg.vue?vue&type=template&id=7211b338&scoped=true&"
import script from "./ChangeOrg.vue?vue&type=script&lang=js&"
export * from "./ChangeOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7211b338",
  null
  
)

export default component.exports